const OrderFormActiveTab = {
  Documents: 'documents',
  Invoices: 'invoices',
  Status: 'status',
  Information: 'information',
}
export { OrderFormActiveTab }
